module.exports = __webpack_public_path__ + "img/BG2-icon.a163cb6c.png";